
import { defineComponent } from 'vue'
import { iOlapCrossNavigationParameter } from '../Olap'
import Dialog from 'primevue/dialog'
import olapCrossNavigationDefinitionDialogDescriptor from './OlapCrossNavigationDefinitionDialogDescriptor.json'
import OlapCrossNavigationStepOne from './OlapCrossNavigationStepOne.vue'
import OlapCrossNavigationStepTwo from './OlapCrossNavigationStepTwo.vue'

export default defineComponent({
    name: 'olap-cross-naviagtion-definition-dialog',
    components: { Dialog, OlapCrossNavigationStepOne, OlapCrossNavigationStepTwo },
    props: { visible: { type: Boolean }, sbiExecutionId: { type: String }, selectedCell: { type: Object }, propOlapDesigner: { type: Object } },
    emits: ['selectFromTable', 'close', 'save'],
    data() {
        return {
            olapCrossNavigationDefinitionDialogDescriptor,
            parameters: [] as iOlapCrossNavigationParameter[],
            selectedParameter: null as iOlapCrossNavigationParameter | null,
            cell: null as any,
            olapDesigner: null as any,
            step: 0,
            addNewParameterVisible: false
        }
    },
    watch: {
        propOlapDesigner() {
            this.loadDesigner()
        },
        selectedCell() {
            this.loadCell()
        },
        visible(value: boolean) {
            if (value) {
                this.loadDesigner()
            }
        }
    },
    created() {
        this.loadDesigner()
        this.loadCell()
    },
    methods: {
        loadDesigner() {
            this.olapDesigner = this.propOlapDesigner as any
            if (this.olapDesigner) {
                this.loadCrossNavigationParameters()
            }
        },
        loadCrossNavigationParameters() {
            const fromCellParameters = this.olapDesigner.template?.wrappedObject?.olap?.CROSS_NAVIGATION?.PARAMETERS?.PARAMETER
            const fromMemberParameters = [] as iOlapCrossNavigationParameter[]
            this.olapDesigner?.template?.wrappedObject?.olap?.MDXQUERY?.clickable?.forEach((el: any) => fromMemberParameters.push({ ...el, name: el.clickParameter.name, type: 'From Member' }))

            this.parameters = []
            if (fromCellParameters?.length > 0) this.parameters = this.parameters.concat(fromCellParameters)
            if (fromMemberParameters?.length > 0) this.parameters = this.parameters.concat(fromMemberParameters)
        },
        addNewParameter() {
            this.selectedParameter = {} as iOlapCrossNavigationParameter
            this.addNewParameterVisible = true
        },
        onParameterSelect(parameter: iOlapCrossNavigationParameter) {
            this.selectedParameter = parameter
            this.step = 1
        },
        loadCell() {
            this.cell = this.selectedCell?.cell as any
        },
        deleteParameter(parameter: iOlapCrossNavigationParameter) {
            parameter.type === 'From Cell' ? this.removeCellParameter(parameter) : this.removeMemberParameter(parameter)
            this.loadCrossNavigationParameters()
        },
        removeCellParameter(parameter) {
            const olapDesignerParameters = this.olapDesigner.template.wrappedObject.olap.CROSS_NAVIGATION.PARAMETERS.PARAMETER
            const index = olapDesignerParameters.findIndex((el: any) => el.name === parameter?.name)
            if (index !== -1) olapDesignerParameters.splice(index, 1)
        },
        removeMemberParameter(parameter) {
            const clickable = this.olapDesigner.template.wrappedObject.olap.MDXQUERY.clickable
            const index = clickable.findIndex((el: any) => el.clickParameter.name === parameter.name)
            if (index !== -1) clickable.splice(index, 1)
        },
        closeDialog() {
            this.$emit('close')
            this.step = 0
            this.selectedParameter = {} as iOlapCrossNavigationParameter
            this.cell = null
            this.addNewParameterVisible = false
        },
        save() {
            if (this.selectedParameter) {
                this.selectedParameter.type === 'From Cell' ? this.addFromCellParameter() : this.addFromMemberParameter()
            }

            this.closeDialog()
        },
        addFromCellParameter() {
            const value = this.selectedParameter?.value

            const dimension = value?.substring(value.indexOf('dimension'), value.indexOf('hierarchy'))
            const hierarchy = value?.substring(value.indexOf('hierarchy'), value.indexOf('level'))
            const level = value?.substring(value.indexOf('level') + 1)

            const tempParameter = {
                dimension: dimension?.substring(dimension.indexOf('=') + 1).trim(),
                hierarchy: hierarchy?.substring(hierarchy.indexOf('=') + 1).trim(),
                level: level?.substring(level.indexOf('=') + 1).trim(),
                name: this.selectedParameter?.name,
                type: this.selectedParameter?.type
            }

            if (!this.olapDesigner.template.wrappedObject.olap.CROSS_NAVIGATION) {
                this.olapDesigner.template.wrappedObject.olap.CROSS_NAVIGATION = {
                    PARAMETERS: {
                        PARAMETER: []
                    }
                }
            }

            const olapDesignerParameters = this.olapDesigner.template.wrappedObject.olap.CROSS_NAVIGATION.PARAMETERS.PARAMETER

            const index = olapDesignerParameters.findIndex((el: any) => el.name === this.selectedParameter?.name)
            index !== -1 ? (olapDesignerParameters[index] = tempParameter) : olapDesignerParameters.push(tempParameter)
        },
        addFromMemberParameter() {
            if (!this.selectedParameter) {
                return
            }

            if (!this.olapDesigner.template.wrappedObject.olap.MDXQUERY.clickable) {
                this.olapDesigner.template.wrappedObject.olap.MDXQUERY.clickable = []
            }
            const clickable = this.olapDesigner.template.wrappedObject.olap.MDXQUERY.clickable
            const tempParameter = { clickParameter: { name: this.selectedParameter.name, value: '{0}' }, name: this.selectedParameter.name, type: this.selectedParameter.type, uniqueName: this.selectedParameter.value }

            const index = clickable.findIndex((el: any) => el.clickParameter.name === this.selectedParameter?.name)
            index !== -1 ? (clickable[index] = tempParameter) : clickable.push(tempParameter)
        }
    }
})
